// Labels for the Menu page summaries and item filters (ar/en).
const TEXT = {
  ar: {
    overviewTitle: "نظرة عامة على قوائم طعام المطعم",
    overviewScope: "كل قوائم طعام المطعم",
    overviewNote: "إحصاءات المحتوى والجودة تشمل قوائم الطعام المفعّلة والمسودات فقط.",
    branchScopeNote: "تشمل قوائم الطعام المرتبطة بفرعك فقط.",
    selectedTitle: "قائمة الطعام المحددة",
    selectedScope: "قائمة الطعام هذه فقط",
    menus: "قوائم الطعام",
    menusWithIssues: "قوائم طعام بها مشاكل",
    ofInUse: (n) => `من ${n} قيد الاستخدام`,
    content: "المحتوى",
    sections: "الأقسام",
    items: "الأصناف",
    branches: "الفروع",
    inclBoxes: (n) => `منها ${n} بوكس`,
    emptySections: (n) => `${n} قسم فارغ`,
    hiddenItems: "أصناف مخفية",
    hiddenInSomeBranches: (n) => `و${n} مخفي في بعض الفروع فقط`,
    missingImages: "بدون صور",
    needsAttention: "تحتاج مراجعة",
    pricingIssues: "مشاكل التسعير",
    contentQuality: "جودة المحتوى",
    additions: "الإضافات المستخدمة",
    additionsOnItems: (n) => `على ${n} صنف`,
    brokenAdditions: (n) => `${n} إضافة غير متاحة`,
    noPricing: "بدون أسعار",
    noBasePrice: "بدون سعر أساسي",
    invalidPricing: "سعر أو خصم غير صحيح",
    missingArabicName: "بدون اسم عربي",
    missingEnglishName: "بدون اسم إنجليزي",
    missingDescription: "بدون وصف",
    descriptionsHint: (n) => `${n} صنف بدون وصف`,
    itemIssues: "أصناف تحتاج مراجعة",
    noBranches: "مفعّل بدون فروع",
    noItems: "بدون أصناف",
    emptySectionsLabel: "أقسام فارغة",
    allGood: "لا توجد مشاكل",
    notAssigned: "غير مرتبط بأي فرع",
    showItems: "اعرض الأصناف",
    showMenus: "اعرض قوائم الطعام",
    loadError: "تعذر تحميل ملخص قوائم الطعام.",
    retry: "إعادة المحاولة",
    noSections: "لا توجد أقسام في قائمة الطعام هذه بعد.",
    noItemsYet: "لا توجد أصناف في قائمة الطعام هذه بعد.",
    archivedNote: "قائمة الطعام مؤرشفة: للقراءة فقط ولا تدخل في إحصاءات المحتوى.",
    draftNote: "فعّل قائمة الطعام ليمكن ربطها بالفروع.",
    copiedNote: "نسخة مستقلة من قائمة طعام أخرى",
    filteredBy: "تصفية قوائم الطعام:",
    clearFilter: "إلغاء التصفية",
    noMenusMatch: "لا توجد قوائم طعام تطابق هذه التصفية.",
    noItemsMatch: "لا توجد أصناف تطابق هذه التصفية.",
    filters: { all: "كل الأصناف", visible: "الظاهرة", hidden: "المخفية", noImage: "بدون صور", attention: "تحتاج مراجعة", pricing: "مشاكل التسعير", names: "أسماء ناقصة", noDescription: "بدون وصف" },
  },
  en: {
    overviewTitle: "Restaurant menu overview",
    overviewScope: "All restaurant menus",
    overviewNote: "Content and quality totals cover active and draft menus.",
    branchScopeNote: "Only menus assigned to your branch.",
    selectedTitle: "Selected menu",
    selectedScope: "This menu only",
    menus: "Menus",
    menusWithIssues: "Menus with issues",
    ofInUse: (n) => `of ${n} in use`,
    content: "Content",
    sections: "Sections",
    items: "Items",
    branches: "Branches",
    inclBoxes: (n) => `incl. ${n} ${n === 1 ? "box" : "boxes"}`,
    emptySections: (n) => `${n} empty ${n === 1 ? "section" : "sections"}`,
    hiddenItems: "Hidden items",
    hiddenInSomeBranches: (n) => `+${n} hidden in some branches`,
    missingImages: "Missing images",
    needsAttention: "Needs attention",
    pricingIssues: "Pricing issues",
    contentQuality: "Content quality",
    additions: "Additions used",
    additionsOnItems: (n) => `on ${n} ${n === 1 ? "item" : "items"}`,
    brokenAdditions: (n) => `${n} unavailable`,
    noPricing: "No pricing",
    noBasePrice: "No base price",
    invalidPricing: "Invalid price or discount",
    missingArabicName: "Missing Arabic name",
    missingEnglishName: "Missing English name",
    missingDescription: "Missing description",
    descriptionsHint: (n) => `${n} without a description`,
    itemIssues: "Items need attention",
    noBranches: "Active without branches",
    noItems: "No items",
    emptySectionsLabel: "Empty sections",
    allGood: "No issues",
    notAssigned: "Not assigned to any branch",
    showItems: "Show items",
    showMenus: "Show menus",
    loadError: "Could not load the menu summary.",
    retry: "Retry",
    noSections: "This menu has no sections yet.",
    noItemsYet: "This menu has no items yet.",
    archivedNote: "Archived: read-only and excluded from content totals.",
    draftNote: "Activate the menu to assign it to branches.",
    copiedNote: "Independent copy of another menu",
    filteredBy: "Menus filtered by:",
    clearFilter: "Clear filter",
    noMenusMatch: "No menus match this filter.",
    noItemsMatch: "No items match this filter.",
    filters: { all: "All items", visible: "Visible", hidden: "Hidden", noImage: "Missing images", attention: "Needs attention", pricing: "Pricing issues", names: "Missing names", noDescription: "Missing description" },
  },
};

export const summaryText = (lang) => TEXT[lang] || TEXT.ar;
